import React, { Component } from 'react';
import './header.css'
import {
  Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Card, Badge, Spinner
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeLang, sendLogout, changeType } from '../../../Redux/Action/LoginAction'
import String from '../../../Assets/locals'
import arabic from "../../../Assets/images/arabic.jpg"
import english from "../../../Assets/images/english.png"
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios'
import { API_ENDPOINT } from '../../../AppConfig'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

class Header extends Component {

  constructor(props) {
    super(props);

    this.toggleTablet = this.toggleTablet.bind(this);
    this.togglemenutab = this.togglemenutab.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      collapse: false,
      collapsemenutab: false,
      flag: false,
      notidata: [],
      noData: false,
      currentlang: "ar",
    };
  }

  getNotioficationData(lang) {
    this.props.showLoading();
    let uri = `${API_ENDPOINT}/notif`
    let token = `Bearer ${this.props.token}`
    axios.get(uri, {
      headers: {
        Authorization: token,
        "Accept-Language": lang
      }
    }).then(response => {
      this.setState({
        notidata: response.data.data,
        noData: true
      })
      console.log("notifiaction data", response.data)
      this.props.hideLoading();
    })
  }

  UNSAFE_componentWillMount() {
    let currentlang = this.props.lang
    this.setState({ currentlang: currentlang })
    // this.getNotioficationData(this.props.lang)
  }

  togglemenutab() {
    this.setState(state => ({ collapsemenutab: !state.collapsemenutab }));
  }
  toggleTablet() {
    this.setState(state => ({ collapse: !state.collapse, collapsemenutab: false }));
  }
  toggle() {
    let mql = window.matchMedia('(max-width: 500px)');
    console.log("find out medi js", mql)
    if (mql.matches) {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }

  lang = () => {
    if (this.props.lang === "ar") {
      this.props.changeLang("en")
    } else {
      this.props.changeLang("ar")
    }
  }
  sendLogout = () => {
    this.setState({ flag: true })
    this.props.sendLogout()

  }

  render() {
    String.setLanguage(this.props.lang);
    if (this.state.currentlang !== this.props.lang) {
      // this.getNotioficationData(this.props.lang)
      this.setState({ currentlang: this.props.lang })
    }
    if (this.props.user && !this.state.noData) {
      this.getNotioficationData(this.props.lang)
    }
    let header = [{ path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.home }, { path: "/Aboutus", title: String.about }, { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.administration }, { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.faculties },
    { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.deanships }, { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.centers }, { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.employment }, { path: "/Contactus", title: String.contactUs }]
    // let SideMenu = [
    //   //   { path: "/", title: String.vice }, { path: "/", title: String.vision }, { path: "/", title: String.administrationMember }, { path: "/", title: String.publicationRule },
    //   // { path: "/", title: String.regulation }, { path: "/", title: String.completeIssues }, { path: "/", title: String.privateIssues }, { path: "/", title: String.editorialBoard }
    //   //   , { path: "/", title: String.forms }, { path: "/", title: String.news }, { path: "/", title: String.mailing }
    // ]

    let menu = []
    if (this.props.screenType === 'MAGAZINE') {
      menu = [{ path: "/Magazin", title: String.vice }, { path: "/Magazin", title: String.vision }, { path: "/Magazin", title: String.administrationMember }, { path: "/PublishRules", title: String.publicationRule },
      { path: "/Regulations", title: String.regulation }, { path: "/volumes/fullvolumes", type: 'FULL', title: String.completeIssues }, { path: "/volumes/specialvolumes", type: 'PRIVATE', title: String.privateIssues }, { path: "/Members", title: String.editorialBoard }
        , { path: "/Magazin", title: String.forms }, { path: "/AllNews", title: String.news }, { path: "/Magazin", title: String.mailing }
      ]
      // sideMenu = menu
    } else {
      menu = [{ path: "/promotion", title: String.vice }, { path: "/promotion", title: String.vision }, { path: "/promotion", title: String.administrationMember }, { path: "/PublishRules", title: String.publicationRule },
      { path: "/Regulations", title: String.regulation }, { path: "/Members", title: String.editorialBoard }
        , { path: "/promotion", title: String.forms }, { path: "/AllNews ", title: String.news }, { path: "/promotion", title: String.mailing }
      ]
      // sideMenu = menu
    }
    let type = localStorage.getItem("JazanType")
    if (this.state.flag) {
      this.setState({ flag: false })
      if (type === 'MAGAZINE') {
        this.props.changeType('MAGAZINE')
        return (
          <Redirect to='/Magazin' />
        )
      }

      if (type === 'PROMOTION') {
        this.props.changeType('MAGAZINE')
        return (
          <Redirect to='/Promotion' />
        )
      }

    }

    return (
      <div>
        <Navbar style={{ direction: this.props.lang === "ar" ? "rtl" : "ltr", textAlign: this.props.lang === "ar" ? "right" : "left" }} expand="md" dark>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar style={{ direction: this.props.lang === "ar" ? "rtl" : "ltr", }} className="collapseMenuresponseive">
            <Nav className={this.props.lang === "ar" ? "ml-auto pr-0" : "mr-auto pl-0"} navbar>
              {header.map((element, index) => {
                return (
                  <NavItem onClick={this.toggle} className="headertablet" key={index}>
                    <Link to={element.path} className="nav-link" >{element.title}
                    </Link>
                  </NavItem>
                )
              })}
              <NavItem className="tabletScreen" style={{ textAlign: this.props.lang === "ar" ? "right" : "left" }}>
                <Button onClick={this.toggleTablet} style={{ marginBottom: '1rem' }}>
                  <span className="navbar-toggler-icon"></span>
                </Button>
                <Collapse isOpen={this.state.collapse}>
                  <Card>
                    {header.map((element, index) => {
                      return (
                        <h5 key={index}>
                          <Link to={element.path}>{element.title}</Link>
                        </h5>
                      )
                    })}
                  </Card>
                </Collapse>
                <h5 onClick={this.togglemenutab} style={{ marginBottom: '1rem', display: this.state.collapse ? "block" : "none" }}>مجلة الجامعة</h5>
                <Collapse isOpen={this.state.collapsemenutab} style={{ width: "75vh" }}>
                  <Card style={{ backgroundColor: "#fff", width: "100%", padding: "10px", textAlign: "center" }}>
                    {menu.map((element, index) => {
                      return (
                        <h5 key={index} style={{ fontSize: "1rem" }}>
                          <Link style={{ color: "#000" }} to={element.path}>{element.title}</Link>
                        </h5>
                      )
                    })}
                  </Card>
                </Collapse>
              </NavItem>

              <UncontrolledDropdown nav inNavbar className="mobileScreenmenu">
                <DropdownToggle nav>
                  {String.magazineUni}
                </DropdownToggle>
                <DropdownMenu right>
                  {menu.map((element, index) => {
                    return (
                      <DropdownItem key={index} onClick={this.toggle}>
                        <Link style={{ color: "#000" }} to={element.path}>{element.title}</Link>
                      </DropdownItem>
                    )
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
            <Nav style={{ left: this.props.lang === "ar" ? "0" : "", right: this.props.lang === "en" ? "0" : "" }} className={this.props.lang === "ar" ? "mr-auto optionsNav pr-0" : "pl-0 ml-auto optionsNav"} navbar>

              {this.props.user &&
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav>
                    <p style={{ position: "relative", marginBottom: "0" }}>
                      <Badge className="badgeNotification" style={{ right: this.props.lang === "en" ? "-10px" : "", left: this.props.lang === "ar" ? "-10px" : "" }}> {this.state.notidata.length} </Badge>
                      <i className="fa fa-bell fa-1.5x"></i>
                    </p>
                  </DropdownToggle>
                  <DropdownMenu className={this.props.lang === "ar" ? "box-arrow box-arrowarnoti" : "box-arrow box-arrowenoti"} style={{
                    right: this.props.lang === "en" ? "-150px" : "auto", left: this.props.lang === "en" ? "auto" : "-150px",
                    textAlign: this.props.lang === "en" ? "left" : "right", minWidth: "18rem"
                  }}>
                    {this.state.notidata.length > 0 ? <span>
                      {this.state.notidata.map((element, index) => {
                        return (
                          <DropdownItem key={index}>
                            test
                        </DropdownItem>
                        )
                      })}
                    </span> : <span>
                        {
                          this.state.noData ? <h4 style={{ color: '#e79422', textAlign: "center", width: "100%" }}>
                            {String.noNotifications}
                          </h4>
                            :
                            <h4 style={{ color: '#e79422', textAlign: "center", width: "100%", margin: "30px 0" }}> <Spinner style={{ width: "3rem", height: "3rem" }} color="info" /> </h4>
                        }
                      </span>

                    }

                  </DropdownMenu>
                </UncontrolledDropdown>}

              {/* <NavItem onClick={this.toggle}>
                <NavLink href="/components/">
                  <i className="fa fa-times fa-1.5x"></i>
                </NavLink>
              </NavItem> */}
              <NavItem onClick={this.toggle}>
                <NavLink href={this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion'}>
                  <i className="fa fa-search fa-1.5x"></i>
                </NavLink>
              </NavItem>
              {!this.props.user &&
                <NavItem>
                  <Link to="/login" className="nav-link" >
                    <i className="fa fa-user fa-1.5x"></i>
                  </Link>
                </NavItem>
              }
              {this.props.user &&
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav>
                    <i className="fa fa-user fa-1.5x"></i>
                  </DropdownToggle>


                  <DropdownMenu className={this.props.lang === "ar" ? "box-arrow box-arrowar" : "box-arrow box-arrowen"} style={{
                    right: this.props.lang === "en" ? "-60px" : "auto", left: this.props.lang === "en" ? "auto" : "-60px",
                    textAlign: this.props.lang === "en" ? "left" : "right", minWidth: "14rem"
                  }}>
                    <DropdownItem>
                      <Link to="/magazine/allpublishing">
                        {String.publishingRequests}
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to="/ProfileSetting">
                        {String.profilesetting}
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link onClick={this.sendLogout}>
                        {String.logoutBTN}
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              }
              <NavItem>
                <NavLink onClick={this.lang} style={{ cursor: "pointer" }}>
                  <img src={this.props.lang === "ar" ? english : arabic} style={{ width: "2rem" }} alt="lang" />
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.login.language,
    user: state.login.user,
    token: state.login.token,
    screenType: state.login.screentype
  }
}
const mapDispatchToProps = dispatch => bindActionCreators(
  {
    changeLang,
    changeType,
    sendLogout,
    showLoading,
    hideLoading
  }
  , dispatch
)
export default connect(mapStateToProps, mapDispatchToProps)(Header);